var cardMap = {
  id: 'id',
  method: 'method',
  methodCardId: 'methodCardId',
  expiryMonth: 'expiryMonth',
  expiryYear: 'expiryYear',
  scheme: 'scheme',
  last4Digits: 'last4Digits',
  verificationChargeId: 'verificationChargeId',
  status: 'status',
  userId: 'userId',
  isDefault: 'isDefault',
  dateCreated: 'dateCreated',
  dateModified: 'dateModified'
};
export default cardMap;